
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class CardButtons extends Vue {
  @Prop() readonly error!: string
}
